export const POST_MESSAGE = 'POST_MESSAGE_BEHAVIOR#POST_MESSAGE';
export const MESSAGE_RECEIVED = 'POST_MESSAGE_BEHAVIOR#MESSAGE_RECEIVED';
export const SET_TARGET_WINDOW = 'POST_MESSAGE_BEHAVIOR#SET_TARGET_WINDOW';
